var React = require('react');

function SignalNoConnection (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.91 17.523v.576h-3v-3.576l-2-2V18.1h-3v-7h1.577l-.985-.984-6.36-6.36 1.27-1.27 17.23 17.23-1.27 1.27-2-2-1.461-1.462zm0-5.08V6.1h-3v3.345l3 3zm5 5V.1h-3v14.345l3 3zm-18 .656h3v-3h-3v3z","fill":"currentColor","fillRule":"evenodd","opacity":".5"}));
}

SignalNoConnection.defaultProps = {"width":"19","height":"21","viewBox":"0 0 19 21"};

module.exports = SignalNoConnection;

SignalNoConnection.default = SignalNoConnection;
